import {Component} from '@angular/core';
import {LabelingService} from 'src/app/shared/labeling.service';
import {PermissionService} from '../permission.service';
import {SecureLocalService} from '../secure-local.service';
// import { MatDialog} from "@angular/material/dialog";
// import {WhatsNewComponent} from "../../whats-new/whats-new.component";

@Component({
    selector: 'landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false
})
export class LandingComponent {

  public showAnnouncements = true;

  constructor(
    public permissionService: PermissionService,
    public secureLocalService: SecureLocalService,
    public labelingService: LabelingService,
    // private matDialog: MatDialog
  ) {
  }

  // openWhatsNew() {
  //     this.matDialog.open(WhatsNewComponent, {
  //       height: '1000px',
  //       width: '950px'
  //     });
  // }
  getRouterLink() {
    return "/reporting/dashboard/11";
  }
}
